import { Pricing, Product, ProductColumnsIds } from '@setvi/shared/interfaces';
import { Cost, Discount, Price, Profit } from './index';

interface PricingProps {
  product: Product;
  pricing: Pricing;
}

export const getGridProductDetailsPricing = ({
  pricing,
  product
}: PricingProps) => {
  const content = {
    [ProductColumnsIds.Price]: (
      <Price label={pricing.label} value={product?.price} />
    ),
    [ProductColumnsIds.Cost]: (
      <Cost label={pricing.label} value={product?.cost} />
    ),
    [ProductColumnsIds.CustomerCost]: (
      <Cost label={pricing.label} value={product?.cost} />
    ),
    [ProductColumnsIds.GP]: (
      <Profit
        label={pricing.label}
        price={product?.price}
        cost={product?.cost}
      />
    ),
    [ProductColumnsIds.Discount]: (
      <Discount
        label={pricing.label}
        price={product?.price}
        cost={product?.cost}
      />
    )
  };

  return content[pricing.id];
};
